export enum RowInputType {
  DollarValue,
  Counter
}
